import React, { useState } from 'react'
import CompanyInfo from './CompanyInfo'
import LegalInfo from './LegalInfo'
import { CiFileOn } from 'react-icons/ci'
import Modal from './Modal'
import { FaRegEye } from 'react-icons/fa'
import UserInfo from './UserInfo'
import Nodata from '../../../components/Atoms/NoData/NoData'
import { getTimeAgo } from '../../../_helpers/getTimeAgo'
import Pagination from '../../../components/Pagination/Pagination'

const MerchantDecline = ({ handleAction, data, size, pageNo, total, onPageChange,count }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedDocumentData, setSelectedDocumentData] = useState(null);
    const [selectedDocumentTitle, setSelectedDocumentTitle] = useState("");
    const documents = [
        'Certificate of Incorporation',
        'Articles of Association',
        'Memorandum of Association',
        'Tax registration certificate',
        'Board resolution & Operating instructions (on company letterhead)',
    
    ]

    const documentMapping = {
        'Certificate of Incorporation': 'certificateOfIncorporation',
        'Articles of Association': 'articlesOfAssociation',
        'Memorandum of Association': 'memorandumOfAssociation',
        'Tax registration certificate': 'taxRegistrationCertificate',
        'Board resolution & Operating instructions (on company letterhead)': 'boardOperatingInstructions',
        'Charges (%)': null,
        'Hold Time (Days)': null
    };

    const handleDocumentClick = (documentName, entityDocument) => {
        const docKey = documentMapping[documentName];

        // Only open modal if this document type has an associated file
        if (docKey && entityDocument && entityDocument[docKey]) {
            // For single document display
            setSelectedDocumentData({ [documentName]: entityDocument[docKey] });
            setSelectedDocumentTitle(documentName);
            setIsModalOpen(true);
        }
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedDocumentData(null);
        setSelectedDocumentTitle("");
    };

    return (
        <div>
            <div className='mb-6'>
                <span className='text-[#0F172A] border-b-2 border-[#00811D]  pb-2'>Merchant Apps Declined ({count})</span>
            </div>

            <div className='space-y-3'>

                {
                    data && data.length > 0 ? (
                        data.map((ele, index) => (
                            <>

                                <div className="flex justify-between items-center mb-4 bg-white p-3 border border-[#D2D2D2] rounded-md">
                                    <div className="flex items-center gap-1">
                                        <span className="text-[#F6465D] font-medium mr-2">Declined by {`(${ele?.verifiedBy?.userName} , ${ele?.verifiedBy?.employeeId} )`}</span>
                                        <div className="flex space-x-2">
                                            <button onClick={() => handleAction("VIEW", ele)}>
                                                <FaRegEye className="text-[22px] text-blue-500" title='View'/>
                                            </button>

                                        </div>
                                    </div>
                                    <div className=" text-[#F6465D]">
                                        {getTimeAgo(ele?.updatedAt)}
                                    </div>
                                </div>

                                <div className="grid md:grid-cols-4 grid-cols-1 gap-4 border border-[#D2D2D2] rounded-md bg-white max-h-[452px] overflow-hidden overflow-y-auto">
                                    <div className="col-span-1 space-y-2 border-b-2 md:border-r-2 p-4">
                                        {documents.map((item, index) => (
                                            <div key={index} className="flex justify-between text-md">
                                                <span className='px-3'>{item}</span>
                                                {index > 4 && (
                                                    <div className=''>
                                                        <span className="font-medium flex justify-start gap-2 items-center">
                                                        
                                                        </span>
                                                    </div>
                                                )}
                                                {index <= 4 && (
                                                    <div>
                                                        <CiFileOn
                                                            size={16}
                                                            className={`text-black ${documentMapping[item] && ele?.entityDocument?.[documentMapping[item]] ? 'cursor-pointer hover:text-blue-500' : 'opacity-50'}`}
                                                            onClick={() => handleDocumentClick(item, ele?.entityDocument)}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        ))}
                                        
                                    </div>
                                    <div className='col-span-2 '>

                                        <div className='grid md:grid-cols-2 grid-cols-1 w-full h-full'>
                                            {
                                                ele?.uboInformation && ele?.uboInformation.length > 0 ? ele?.uboInformation?.map((document, index) => (
                                                    <>
                                                        <div className='border-b-2 md:border-r-2 p-3 space-y-3'>
                                                            {ele?.entityInformation?.websiteLogo &&
                                                                <img src={ele?.entityInformation?.websiteLogo} className='max-w-[200px] max-h-[52px] w-full  h-auto mx-auto' alt='logo' />
                                                            }
                                                            {document?.documentFrontImage &&
                                                                <img src={document?.documentFrontImage} className='w-auto h-auto max-w-[192px] max-h-[115px] mx-auto' alt='' />
                                                            }
                                                            {document?.documentBackImage &&
                                                                <img src={document?.documentBackImage} className='w-[192px] h-[115px] mx-auto' alt='' />
                                                            }
                                                        </div>
                                                    </>
                                                )) : (<div>No Data Found</div>)
                                            }

                                            <div className="border-b-2 md:border-r-2 p-3">
                                                {/* Image of account maintenance letter */}
                                                {ele?.bankInformation?.accountMaintenanceLetter &&
                                                    <img
                                                        src={ele?.bankInformation?.accountMaintenanceLetter}
                                                        alt="Account Maintenance Letter"
                                                        className="max-w-[202px] max-h-[280px] mx-auto rounded"
                                                    />
                                                }

                                                {/* Country and label */}
                                                <div className="flex justify-between items-center max-w-[202px] mx-auto mt-3">
                                                    <div className="flex items-center gap-2">
                                                        <img src="/img/Group.png" alt="flag" className="w-4 h-4" />
                                                        <span>India</span> {/* You can replace with dynamic country name if needed */}
                                                    </div>
                                                    <span className="text-xs text-gray-500">{ele?.bankInformation?.bankName || "N/A"}</span>
                                                </div>
                                                <div className="flex justify-between items-center max-w-[202px] mx-auto ">
                                                    <span>Account No.:</span>
                                                    <span className="text-xs text-gray-500">{ele?.bankInformation?.accountNumber || "N/A"}</span>
                                                </div>
                                                <div className="flex justify-between items-center max-w-[202px] mx-auto ">
                                                    <span>Account Type:</span>
                                                    <span className="text-xs text-gray-500"> {ele?.bankInformation?.accountType || "N/A"}</span>
                                                </div>
                                                <div className="flex justify-between items-center max-w-[202px] mx-auto ">
                                                    <span>IFSC:</span>
                                                    <span className="text-xs text-gray-500">{ele?.bankInformation?.ifscCode || "N/A"}</span>
                                                </div>
                                                <div className="flex justify-between items-center max-w-[202px] mx-auto ">
                                                    <span>Branch Code:</span>
                                                    <span className="text-xs text-gray-500">{ele?.bankInformation?.branchCode || "N/A"}</span>
                                                </div>
                                                <div className="flex justify-between items-center max-w-[202px] mx-auto ">
                                                    <span>IBAN:</span>
                                                    <span className="text-xs text-gray-500">{ele?.bankInformation?.iban || "N/A"}</span>
                                                </div>
                                                <div className="flex justify-between items-center max-w-[202px] mx-auto ">
                                                    <span>Bank Address:</span>
                                                    <span className="text-xs text-gray-500">{ele?.bankInformation?.bankAddress || "N/A"}</span>
                                                </div>

                                            </div>

                                        </div>

                                    </div>
                                    <div className='max-h-[450px] overflow-hidden overflow-y-auto'>
                                        <CompanyInfo data={ele?.companyInformation} />
                                        <LegalInfo data={ele?.entityInformation} />
                                        <UserInfo data={ele} />
                                    </div>



                                </div>
                            </>
                        ))
                    ) : (
                        <div className='border rounded-md'>
                            <Nodata
                                nodataLabel={"Don't Have Decline Merchant "}
                                nodataDesc={'Add New User here click to below button '}
                                buttonLabel={'+ Add User'}
                            />
                        </div>
                    )
                }

            </div>

            {Math.ceil(total / size) >
                1 && (
                    <Pagination
                        totalPages={Math.ceil(
                            total / size
                        )}
                        currentPage={pageNo}
                        onPageChange={onPageChange}
                    />
                )}


            {isModalOpen && (
                <Modal
                    isOpen={isModalOpen}
                    onClose={closeModal}
                    documentData={selectedDocumentData}
                    title={selectedDocumentTitle}
                />
            )}




        </div>

    )
}

export default MerchantDecline